// ContactForm.tsx
import { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import classes from './styles.module.css';
import { TFunction } from 'i18next';
import BtnSpinner from './Spinner';
import { toast } from 'react-toastify';
import axios from 'axios';
import { capitalizeWord } from 'src/utils/global';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ReCaptchaProvider from 'src/hoc/ReCaptchaProvider';
import baseUrl from 'src/constants/vars';
import { toastOptions } from 'src/constants/toast';


// Define the form values type
interface FormValues {
    fullname: string;
    email: string;
    phone_number: string;
    subject: string;
    message: string;
}

const initialValues: FormValues = {
    fullname: '',
    email: '',
    phone_number: '',
    subject: '',
    message: '',
};


const fields = [
    { id: 'fullname', name: 'form.fullname', type: "text", classes: "col-md-6 col-12" },
    { id: 'email', name: 'form.email', type: "email", classes: "col-md-6 col-12" },
    { id: 'phone_number', name: 'form.phone', type: "tel", classes: "col-md-6 col-12" },
    { id: 'subject', name: 'form.subject', type: "text", classes: "col-md-6 col-12" },
    { id: 'message', name: 'form.message', as: "textarea", classes: "col-12" },
];


const spaceValidator = (value: any) => value && value.trim() !== ''

const validationSchema = (t: TFunction) => Yup.object({
    fullname: Yup.string().required(t('form.error.required_field')).test('no-spaces', t('form.error.space'), spaceValidator),
    email: Yup.string().email(t('form.error.invalid_email')).required(t('form.error.required_field')).test('no-spaces', t('form.error.space'), spaceValidator),
    phone_number: Yup.string()
        .required(t('form.error.required_field'))
        .test('no-spaces', t('form.error.space'), spaceValidator)
        .matches(/^(?:\+\d{1,3}\s?)?(?:\(\d{1,4}\))?(?:[\d-.\s]){8,}$/, t('form.error.invalid_phone_number')),
    subject: Yup.string().required(t('form.error.required_field')).test('no-spaces', t('form.error.space'), spaceValidator),
    message: Yup.string().required(t('form.error.required_field')).test('no-spaces', t('form.error.space'), spaceValidator),
});


const ContactForm = ({ t, lang }: { t: TFunction, lang: string }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const onSubmit = async (values: FormValues, { resetForm }: any) => {
        if (executeRecaptcha) {
            const recaptchaToken = await executeRecaptcha();
            if (!recaptchaToken) {
                toast.error(t("invalid_recaptcha"))
            }
            else {
                setIsLoading(true);
                try {
                    console.log("options ", toastOptions)
                    // ${process.env.NEXT_PUBLIC_BASE_URL}
                    const res = await axios.post(`${baseUrl}/emails/send/`, { ...values, token: recaptchaToken });
                    toast.success(t("form.success_msg"), { ...toastOptions, autoClose: false });

                } catch (err) {
                    toast.error(t("form.error_msg"), { ...toastOptions, autoClose: 5000 });

                }
            }
        }
        setIsLoading(false);
        resetForm();
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={() => validationSchema(t)}
            onSubmit={onSubmit}
        >
            {({ isSubmitting, isValid, resetForm }) => (
                <Form>
                    <div className='row'>
                        {fields.map(item => {
                            return <div key={`field-${item.id}`} className={`${item.classes} mb-4`}>
                                <div className={classes.field}>
                                    <Field className={classes.input} as={item.as ? item.as : null}
                                        type={item.type ? item.type : null}
                                        id={item.id} name={item.id} placeholder={capitalizeWord(t(item.name))} />
                                    <ErrorMessage className={classes.error} name={item.id} component="div" />
                                </div>
                            </div>
                        })}

                        <div className="col-12">
                            <button type="submit"
                                className={`${classes.form_btn} bttn_primary`}

                                disabled={isSubmitting || isLoading || !isValid || !executeRecaptcha ? true : false} >
                                <span>
                                    {isSubmitting || isLoading ? <BtnSpinner /> : t("form.submit")}
                                </span>
                            </button>
                        </div>
                    </div>
                </Form>
            )}


        </Formik>
    );
};

export default ReCaptchaProvider(ContactForm);
